// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"45022896","697":"9edf5c38"}[chunkId] + ".chunk.css";
};